const FEDEX_PRODUCTS = {
    INTERNATIONAL_ECONOMY: {
        serviceType: "INTERNATIONAL_ECONOMY",
        originalName: "Fedex International Economy",
        friendlyName: "Fedex Ekonomi",
    },
    FEDEX_INTERNATIONAL_PRIORITY: {
        serviceType: "FEDEX_INTERNATIONAL_PRIORITY",
        originalName: "Fedex International Priority",
        friendlyName: "Fedex Express",
        oldServiceType: "INTERNATIONAL_PRIORITY",
    },
    INTERNATIONAL_ECONOMY_FREIGHT: {
        serviceType: "INTERNATIONAL_ECONOMY_FREIGHT",
        originalName: "Fedex International Economy Freight",
        friendlyName: "Fedex Ekonomi",
    },
    INTERNATIONAL_PRIORITY_FREIGHT: {
        serviceType: "INTERNATIONAL_PRIORITY_FREIGHT",
        originalName: "Fedex International Priority Freight",
        friendlyName: "Fedex Express",
    },
    FEDEX_REGIONAL_ECONOMY: {
        serviceType: "FEDEX_REGIONAL_ECONOMY",
        originalName: "Fedex Regional Economy",
        friendlyName: "Fedex Ekonomi",
    },
    FEDEX_REGIONAL_ECONOMY_FREIGHT: {
        serviceType: "FEDEX_REGIONAL_ECONOMY_FREIGHT",
        originalName: "Fedex Regional Economy Freight",
        friendlyName: "Fedex Ekonomi",
    },
};

module.exports = {
    FEDEX_PRODUCTS,
};
